import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { ByTheNumbers } from '../components/ByTheNumbers';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-2356">
      <div className="dark" data-id="element-2357">
        <Hero data-id="element-2358" />
      </div>
      <WhyUs data-id="element-2359" />
      <ByTheNumbers data-id="element-2360" />
      <Services data-id="element-2361" />
      <HowItWorks data-id="element-2362" />
      <FAQ data-id="element-2363" />
      <Reviews data-id="element-2364" />
      <CtaBanner data-id="element-2365" />
    </main>;
}